var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoctorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 34,
    viewBox: "0 0 41 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 17,
    r: 14,
    fill: "#CFE5F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5411 20.1176H31.9114C36.2399 20.1176 39.7955 23.6216 39.7955 28.0016C39.7955 30.7327 37.5797 33 34.7971 33H17.9984C15.2158 32.9485 13 30.7327 13 27.9501C13 23.6216 16.504 20.066 20.8841 20.066H23.306",
    stroke: "#306AFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5411 18.4171V20.2207C29.5411 21.0967 29.1804 21.8696 28.6135 22.4364C28.0467 23.0033 27.2737 23.364 26.3977 23.364C24.6457 23.364 23.2544 21.9727 23.2544 20.2207V18.4686",
    stroke: "#306AFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2625 17.9017C31.8083 18.417 32.942 19.8599 32.942 21.5603V27.1256",
    stroke: "#306AFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9565 23.467V21.5603C19.9565 19.8599 21.0386 18.4686 22.533 17.9017",
    stroke: "#306AFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3784 30.0629H22.7391C23.0998 30.0629 23.409 29.7537 23.409 29.393V26.9195C23.409 25.0129 21.8631 23.467 19.9565 23.467C18.0499 23.467 16.504 25.0129 16.504 26.9195V29.393C16.504 29.7537 16.8132 30.0629 17.1739 30.0629H17.6377",
    stroke: "#306AFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.942 30.7842C33.9666 30.7842 34.7971 29.9537 34.7971 28.9292C34.7971 27.9046 33.9666 27.0741 32.942 27.0741C31.9175 27.0741 31.087 27.9046 31.087 28.9292C31.087 29.9537 31.9175 30.7842 32.942 30.7842Z",
    stroke: "#306AFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6264 11.4606V11.5636V13.6764V13.7279V13.934C20.6264 14.0886 20.6264 14.1917 20.6779 14.3462V14.5008C20.8841 15.8406 21.6055 17.0258 22.5845 17.9018C22.7907 18.1079 23.0483 18.314 23.306 18.4686C24.285 19.087 25.4702 19.4477 26.7069 19.3962C27.7375 19.3446 28.7166 18.9839 29.5411 18.4686C29.7987 18.314 30.0048 18.1079 30.2625 17.9018C31.4992 16.7681 32.2206 15.1707 32.2206 13.4187V11.6152V11.5636",
    stroke: "#306AFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2721 11.5636C33.0966 11.6151 33.715 12.2335 33.715 13.0064C33.715 13.7794 33.0451 14.4493 32.1691 14.4493",
    stroke: "#306AFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6264 11.5636C19.8019 11.6151 19.1836 12.2335 19.1836 13.0064C19.1836 13.7794 19.8535 14.4493 20.7295 14.4493",
    stroke: "#306AFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3478 11.2029L21.9147 8.93559C22.0177 8.47182 22.5845 8.21417 22.9968 8.42029C24.2335 9.03865 26.7585 9.91465 30.3655 9.24477C30.7778 9.14171 31.19 9.45089 31.2931 9.86312L31.4992 11.0998C31.5507 11.306 31.7568 11.5121 31.963 11.5121H32.066C32.2206 11.5121 32.3752 11.409 32.4783 11.2544C32.7874 10.6876 33.0451 10.1208 33.1997 9.60548C34.1787 6.51369 32.8905 3.06119 30.0048 1.61836C29.0773 1.20612 28.2013 1 27.3253 1C25.1095 1 23.2029 2.23671 22.1208 3.11272C21.657 3.52496 21.1417 3.83414 20.5749 4.09179C18.256 5.12238 19.5443 9.19324 20.4203 11.2544C20.4718 11.409 20.6779 11.5636 20.8325 11.5636C21.0902 11.5636 21.2963 11.409 21.3478 11.2029Z",
    stroke: "#306AFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorIcon);
export default __webpack_public_path__ + "static/media/DoctorIcon.c918bb2c0d0314165d705894ce96c590.svg";
export { ForwardRef as ReactComponent };